<template>
    <div id="counter" class="d-sm-none d-none" v-if="availableEvents.length > 0">
        <div class="card">
            <div v-for="event in availableEvents" class="card-body mb-2" :key="'event-' + event.id">
                Počet prihlásených na {{event.name}}: <strong>{{event.payedParticipantCount}}</strong>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Counter',
    computed: {
      ...mapGetters(['availableEvents'])
    }
  };
</script>

<style scoped>

</style>
